/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grim_Bold_Crane_WarnInputs */

const en_grim_bold_crane_warn = /** @type {(inputs: Grim_Bold_Crane_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once saved, the selection cannot be changed.`)
};

const de_grim_bold_crane_warn = /** @type {(inputs: Grim_Bold_Crane_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einmal gespeichert, kann die Auswahl nicht mehr geändert werden.`)
};

/**
* | output |
* | --- |
* | "Once saved, the selection cannot be changed." |
*
* @param {Grim_Bold_Crane_WarnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const grim_bold_crane_warn = /** @type {((inputs?: Grim_Bold_Crane_WarnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grim_Bold_Crane_WarnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_grim_bold_crane_warn(inputs)
	return de_grim_bold_crane_warn(inputs)
});